import { NgClass, NgTemplateOutlet } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    inject
} from "@angular/core";
import { RaskPopoverDirective } from "../../directives/popover/rask-popover.directive";

@Component({
    selector: "rask-icon-stacked",
    templateUrl: "./icon-stacked.component.html",
    styleUrls: ["./icon-stacked.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RaskPopoverDirective,
        NgClass,
        NgTemplateOutlet
    ]
})
export class IconStackedComponent implements OnInit, AfterViewInit {
    @Input() clickToOpen: boolean;
    @Input() customTriggers: string;
    @Input() icon: string;
    @Input() icon2: string;
    @Input() popoverClass?: string;
    @Input() popoverContainer?: string;
    popoverDisabled = false;
    @ViewChild("templateResult") templateResult;
    @Input() text: string;
    triggers = "mouseenter:mouseleave";

    private readonly changeRef = inject(ChangeDetectorRef);

    ngAfterViewInit(): void {
        this.popoverDisabled = this.templateResult.nativeElement.innerText.replace(/ /g, "").length === 0;
        this.changeRef.detectChanges();
    }
    ngOnInit() {
        if (this.clickToOpen === true) {
            this.triggers = "manual";
        }

        if (this.customTriggers) {
            this.triggers = this.customTriggers;
        }
    }

    onOpen(popover) {
        if (this.clickToOpen) {
            popover.open();
        }
    }
}
